import { BrowserModule } from '@angular/platform-browser'; 
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { cabecera } from "./components/cabecera.component";

import { bodyComponent } from "./components/body.component";

import {HttpModule} from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { httpService } from './components/body.service';
import { LoginComponent } from './login/login.component';

import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatosusuarioComponent } from './datosusuario/datosusuario.component';
import { DatosafComponent } from './datosaf/datosaf.component';
import { DocsComponent } from './docs/docs.component';
import { Routes, RouterModule} from '@angular/router'
import { ExploracionComponent } from './exploracion/exploracion.component';
import { AlbaranesComponent } from './albaranes/albaranes.component';
import { PdfViewerModule } from 'cardinal-pdf-viewer';  //'cardinal-pdf-viewer'; 
import { EntregaComponent } from './entrega/entrega.component'; //'ng2-pdf-viewer'
// import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { NgQRCodeReaderModule } from 'ng2-qrcode-reader';
import { SignaturePadModule} from 'angular2-signaturepad'
//import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
 
@NgModule({
  declarations: [
    AppComponent,
    cabecera,
    bodyComponent,
    LoginComponent,
    DatosusuarioComponent,
    DatosafComponent,
    DocsComponent,
    ExploracionComponent,
    AlbaranesComponent,
    EntregaComponent,

  ], 
  imports: [ 
    //CKEditorModule, 
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    PdfViewerModule,
    NgQRCodeReaderModule,
    SignaturePadModule, 
    // ZXingScannerModule,
    ToastModule.forRoot(),
    RouterModule.forRoot([])

  ],
  providers: [
    httpService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/usuario/Desktop/Angular/Urbanos/src/app/app.module.ts